import { render, staticRenderFns } from "./AgentSettlement.vue?vue&type=template&id=dcc27916&scoped=true&"
import script from "./AgentSettlement.vue?vue&type=script&lang=js&"
export * from "./AgentSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc27916",
  null
  
)

export default component.exports